import { createSlice } from "@reduxjs/toolkit";
import {
  sendMailToOthers,
  generateMailApi,
  inboxMailApi,
  readInboxMailApi,
} from "../../api/mailApi";

// Get generatedmail from localStorage
const generatedmail = JSON.parse(localStorage.getItem("generatedmail"));

const initialState = {
  mail: null,
  generatedmail: generatedmail ? generatedmail : null,
  inboxmail: null,
  listinboxmail: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const mailSlice = createSlice({
  name: "mail",
  initialState: initialState,
  reducers: {
    loadMail(state, action) {
      state.isLoading = true;
      state.isSuccess = false;
      state.mail = null;
    },
    emailsendSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.mail = action.payload;
    },
    emailsendFail(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
      state.mail = null;
    },
    generateMailSuccess(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.generatedmail = action.payload;
    },
    generateMailFail(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.generatedmail = null;
      state.message = action.payload;
    },
    listInboxMailSuccess(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.listinboxmail = action.payload;
    },
    listInboxMailFail(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.listinboxmail = [];
      state.message = action.payload;
    },
    readInboxMailSuccess(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.inboxmail = action.payload;
    },
    readInboxMailFail(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.inboxmail = null;
      state.message = action.payload;
    },
  },
});

export const {
  loadMail,
  emailsendSuccess,
  emailsendFail,
  generateMailSuccess,
  generateMailFail,
  listInboxMailSuccess,
  listInboxMailFail,
  readInboxMailSuccess,
  readInboxMailFail,
} = mailSlice.actions;

export const sendMail = (emailData) => async (dispatch, getState) => {
  try {
    dispatch(loadMail());

    const {
      auth: { user },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const mailData = await sendMailToOthers(emailData, config);
    dispatch(emailsendSuccess(mailData));
  } catch (error) {
    dispatch(emailsendFail(error));
  }
};

export const generateMail = () => async (dispatch, getState) => {
  try {
    dispatch(loadMail());

    const {
      auth: { user },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    // console.log(config);

    const mailData = await generateMailApi(config);
    dispatch(generateMailSuccess(mailData));
  } catch (error) {
    dispatch(generateMailFail(error));
  }
};

export const listmailInbox = (email) => async (dispatch) => {
  try {
    dispatch(loadMail());

    const inboxData = await inboxMailApi(email);
    dispatch(listInboxMailSuccess(inboxData));

    // console.log(result.payload.messages);
  } catch (error) {
    dispatch(listInboxMailFail(error));
  }
};

export const readMailInbox = (email, mailId) => async (dispatch) => {
  try {
    dispatch(loadMail());

    const singleMailData = await readInboxMailApi(email, mailId);
    dispatch(readInboxMailSuccess(singleMailData));

    console.log("Readmail by id");
  } catch (error) {
    dispatch(readInboxMailFail(error));
  }
};

export default mailSlice.reducer;
